import styled from 'styled-components'

export const DocumentContainer = styled.div`
  background-color: #FFF;
  width: 40rem;
  height: 90%;
  padding: 1.8rem;
  display: flex;
  flex-direction: column;
  gap: 5rem;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const TableHeader = styled.thead`
  background: #f4f4f4;
  border-bottom: 1px solid #ebebeb;
`

export const TableHeaderCell = styled.th<{ width?: string }>`
  padding: 11px 8px;
  font-family: "Inter", Helvetica;
  font-size: 12px;
  font-weight: 400;
  color: #696969;
  text-align: left;
  line-height: 150%;
  width: ${props => props.width || "auto"};
  
  &:first-child {
    padding-left: 16px;
  }
`

export const TableRow = styled.tr`
  border-bottom: 1px solid #ebebeb;
  
  &:last-child {
    border-bottom: none;
  }
`

export const TableCell = styled.td<{ width?: string }>`
  padding: 17px 8px;
  font-family: "Inter", Helvetica;
  font-size: 12px;
  font-weight: 400;
  color: #303030;
  line-height: 150%;
  width: ${props => props.width || "auto"};
  
  &:first-child {
    padding-left: 16px;
  }
`